import { render, staticRenderFns } from "./AvidiaOnboardingInfo.vue?vue&type=template&id=5cba6420"
import script from "./AvidiaOnboardingInfo.vue?vue&type=script&lang=ts"
export * from "./AvidiaOnboardingInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports